export default __webpack_public_path__ + "static/thumb-landscape-1c7c41c9b48828100928356b9976c207.jpg";